"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaView = void 0;
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_i18next_1 = require("react-i18next");
const lazy_1 = __importDefault(require("react-player/lazy"));
const react_redux_1 = require("react-redux");
const http_requests_1 = require("../../../../shared/http-requests");
const helpers_1 = require("../../../../shared/helpers");
const components_1 = require("../../../../shared/components");
const MediaView = (props) => {
    const { uri, onClosed, title, format, seqParagrafo, isRestricted, codAcervo, userRx, open } = props;
    const modalRef = (0, react_1.useRef)(null);
    const { t } = (0, react_i18next_1.useTranslation)();
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [url, setUrl] = (0, react_1.useState)(uri);
    const { login } = userRx !== null && userRx !== void 0 ? userRx : { login: undefined };
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (open === true) {
            setIsOpen(open);
            if (isRestricted) {
                (() => __awaiter(void 0, void 0, void 0, function* () {
                    setLoading(true);
                    const res = yield processRestricted();
                    setIsOpen(res);
                    setLoading(false);
                }))();
                return;
            }
            setLoading(false);
        }
    }, [open]);
    (0, react_1.useEffect)(() => {
        if (!isOpen && onClosed && typeof onClosed === 'function') {
            onClosed();
        }
    }, [isOpen]);
    const getRestrictedLink = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoading(true);
            const response = yield http_requests_1.VinculosAPI.acessarLinkAcessoRestrito(codAcervo, seqParagrafo, login);
            if (response) {
                const { data } = response;
                return data;
            }
        }
        catch (error) {
            helpers_1.APIHelper.tratarErro(error);
            console.log(error);
        }
    });
    const processRestricted = () => __awaiter(void 0, void 0, void 0, function* () {
        const restrictedLink = yield getRestrictedLink();
        if (!restrictedLink) {
            helpers_1.ToastifyHelper.error("Houve um erro durante a tentativa de acesso ao vinculo.");
            return false;
        }
        setUrl(restrictedLink);
        return true;
    });
    const handleClickView = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsOpen(true);
        if (isRestricted) {
            setLoading(true);
            const res = yield processRestricted();
            setIsOpen(res);
        }
        setLoading(false);
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(reactstrap_1.Modal, { onClosed: () => {
                if (onClosed && typeof onClosed === 'function')
                    onClosed();
            }, innerRef: modalRef, modalClassName: 'tema-pergamum', isOpen: isOpen, toggle: () => setIsOpen(!isOpen), size: 'lg', scrollable: true },
            react_1.default.createElement(reactstrap_1.ModalHeader, { style: { padding: "1rem 1rem 10px 1rem" }, className: "b-solid-bottom b-branco cortxt negrito", toggle: () => setIsOpen(!isOpen), 
                /* eslint-disable-next-line react/button-has-type */
                close: react_1.default.createElement("button", { className: "close s20 branco float-right mr-1 rad5", style: { fontWeight: 'normal' }, onClick: () => setIsOpen(false) },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "times", className: "fa-fw" })) },
                react_1.default.createElement("div", { className: "f700 branco s20 " }, title)),
            react_1.default.createElement(reactstrap_1.ModalBody, { style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: format === 'MP4' ? '350px' : '150px',
                    width: 'auto',
                    height: 'auto'
                } }, 
            // eslint-disable-next-line no-nested-ternary
            loading ? (
            // @ts-ignore
            react_1.default.createElement(components_1.ModalConstructor, { open: true, size: "xs" },
                react_1.default.createElement("div", { className: "p-4 text-center" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(components_1.SpinnerConstructor, { visible: true, height: 60, width: 60, className: "apergamum" }),
                        react_1.default.createElement("div", { className: "mt-3" },
                            react_1.default.createElement("span", { className: "preto70 s17 f400" }, t('Aguarde'))))))) : url ? (react_1.default.createElement(lazy_1.default, { playing: true, controls: true, width: "100%", height: format === 'MP4' ? '100%' : '70px', url: url })) : ''),
            react_1.default.createElement(reactstrap_1.ModalFooter, { className: "d-flex justify-content-center align-items-center position-relative" },
                react_1.default.createElement(reactstrap_1.Button, { onClick: () => setIsOpen(false), className: "danger", title: "Sair" }, t('Sair')))),
        react_1.default.createElement(reactstrap_1.Button, { className: "branco hover hpreto bkverde px-2 py-1 rad5 click sverde b-none", onClick: handleClickView, title: t('AcessarMaterial') },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: format === 'MP4' ? free_solid_svg_icons_1.faFileVideo : free_solid_svg_icons_1.faFileAudio, className: 's15' }))));
};
exports.MediaView = MediaView;
const mapStateToProps = (state) => ({
    userRx: state.auth.user,
});
exports.default = (0, react_redux_1.connect)(mapStateToProps)(exports.MediaView);
